import(/* webpackMode: "eager", webpackExports: ["RaceView"] */ "/vercel/path0/translations/ja/Endings.tsx");
